import React from "react";
import LabourList from "./screens/list/LabourList";
import {createNativeStackNavigator} from "@react-navigation/native-stack";
import {ParamListBase} from "@react-navigation/native";

const Stack = createNativeStackNavigator<LabourStackParamList>();

export default function LabourStack() {
  return (
    <Stack.Navigator>
      <Stack.Screen
        name='list'
        component={LabourList}
        options={{headerShown: false}}
      />

    </Stack.Navigator>
  );
};

export type LabourStackParamList = ParamListBase & {
  list: undefined;
};
